<template>
  <div class="count-down">
    <!--    竞价未开始显示的竞价开始时间-->
    <div
      v-if="
        status === competeHallStatusDict.NOT_STARTED.value ||
          status === competeHallStatusDict.ABOUT_TO_START.value
      "
      class="time-not-start-content flex-column flex-center"
    >
      <div class="time-title">距离竞价开始还有</div>
      <div class="time-con">{{ distanceCompeteStartTime }}</div>
    </div>

    <!--    竞价开始的倒计时-->
    <div
      v-if="status === competeHallStatusDict.COMPETE.value"
      class="time-start-content flex-align__between"
    >
      <div>{{ Math.floor(hour / 10) }}</div>
      <div>{{ hour % 10 }}</div>
      <div>:</div>
      <div>{{ Math.floor(minute / 10) }}</div>
      <div>{{ minute % 10 }}</div>
      <div>:</div>
      <div>{{ Math.floor(second / 10) }}</div>
      <div>{{ second % 10 }}</div>
    </div>

    <!--    竞价结束显示竞价结束的时间-->
    <div
      v-if="status === competeHallStatusDict.COMPETE_END.value"
      class="time-not-start-content flex-column flex-center"
    >
      <div class="time-title">竞价结束时间</div>
      <div class="time-con">{{ competeEndTime }}</div>
    </div>

    <!--    使视觉产生3D效果的容器-->
    <div
      class="box-three-d"
      :class="{ active: status === competeHallStatusDict.COMPETE.value }"
    ></div>

    <!--    展示时间的信息的容器-->
    <div
      class="time-mes-content flex-center"
      :class="{ active: status === competeHallStatusDict.COMPETE.value }"
    >
      {{ competeHallStatusDict.translate(status).label }}
    </div>
  </div>
</template>

<script>
// 引入倒计时处理对象
import DateUtils from '@/utils/date'

// 引入数据字典
import { competeHallStatusDict } from '@/dictionary/project/compete'

export default {
  name: 'CountDown',

  props: {
    // 倒计时时间
    timeLeft: {
      type: Number,
      default: 0
    },

    // 竞价状态 状态看competeHallStatusDict数据字典
    status: {
      validator: value => {
        return (
          competeHallStatusDict.array.findIndex(dict => dict.value === value) >=
          0
        )
      },
      required: true
    },

    // 竞价结束时间 （只在竞价结束后展示）
    competeEndTime: {
      type: [String, Number],
      required: true
    }
  },

  data() {
    return {
      // 数据字典
      competeHallStatusDict,

      dateUtils: new DateUtils()
    }
  },

  computed: {
    second() {
      return (this.timeLeft / 1000) % 60
    },
    minute() {
      return Math.floor(this.timeLeft / 1000 / 60) % 60
    },
    hour() {
      return Math.floor(this.timeLeft / 1000 / 60 / 60)
    },

    // 距离竞价开始的时间文字倒计时
    distanceCompeteStartTime() {
      const temp = DateUtils.formatDuring(this.timeLeft)

      return `${temp.days}天${temp.hours}时${temp.minutes}分${temp.seconds}秒`
    }
  }
}
</script>

<style lang="scss" scoped>
.count-down {
  position: relative;
  width: pixel-to-rem($n: 600);
  height: pixel-to-rem($n: 180);

  // 竞价未开始的时间展示
  .time-not-start-content {
    position: relative;
    z-index: 1;
    margin: 0 pixel-to-rem($n: 45);
    height: pixel-to-rem($n: 100);
    border-radius: pixel-to-rem($n: 8);
    background-color: #e6e6e6;

    .time-title {
      font-size: pixel-to-rem($n: 20);
      color: $third-text-color;
    }
    .time-con {
      margin-top: pixel-to-rem($n: 4);
      font-size: pixel-to-rem($n: 24);
      @include text-bold;
      color: $second-text-color;
    }
  }

  // 竞价开始后的时间显示
  .time-start-content {
    position: relative;
    height: pixel-to-rem($n: 100);
    margin: 0 pixel-to-rem($n: 30);
    z-index: 1;

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      height: 100%;
      color: $primary-color;
      font-size: pixel-to-rem($n: 60);
      @include text-bold;
      background-color: #dfefff;
      border-radius: pixel-to-rem($n: 8);

      & + div {
        margin-left: pixel-to-rem($n: 10);
      }
    }
  }

  .box-three-d {
    position: absolute;
    left: 0;
    top: pixel-to-rem($n: 20);
    width: 100%;
    height: pixel-to-rem($n: 100);
    background: linear-gradient($white-background-color, #b8b8b8);

    &.active {
      background: linear-gradient($white-background-color, $primary-color);
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 0;
      border-top: pixel-to-rem($n: 50) solid $white-background-color;
      border-left: pixel-to-rem($n: 10) solid $white-background-color;
      border-right: pixel-to-rem($n: 10) solid transparent;
      border-bottom: pixel-to-rem($n: 50) solid transparent;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border-top: pixel-to-rem($n: 50) solid $white-background-color;
      border-left: pixel-to-rem($n: 10) solid transparent;
      border-right: pixel-to-rem($n: 10) solid $white-background-color;
      border-bottom: pixel-to-rem($n: 50) solid transparent;
    }
  }

  .time-mes-content {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: pixel-to-rem($n: 60);
    background-color: #ccc;
    color: $white-color;
    @include text-bold;
    font-size: pixel-to-rem($n: 25);
    border-bottom-left-radius: pixel-to-rem($n: 8);
    border-bottom-right-radius: pixel-to-rem($n: 8);

    &.active {
      background-color: $primary-color;
    }
  }
}
</style>
